import { FrameStepHandle } from "..";
import { UnhandledBehaviorError } from "../util/exception";
import { WorkflowManager } from "../WorkflowManager";
import { IllustrationStepHandle } from "./steps/illustration";
import { MaterialStepHandle } from "./steps/material";
import { ModelStepHandle } from "./steps/model";
import { PictureStepHandle } from "./steps/picture";
import { QuestionStepHandle } from "./steps/question";
import { ShapeStepHandle } from "./steps/shape";
import { TextStepHandle } from "./steps/text";
import { InformationStepHandle } from "./steps/information";
import { DigitalContentStepHandle } from "./steps/digitalContent";
import { ModuleStepHandle } from "./steps/module";
import { AnyStepData, DigitalContentStepData, FrameStepData, IllustrationStepData, InformationStepData, MaterialStepData, ModelStepData, ModuleStepData, PictureStepData, QuestionStepData, ShapeStepData, Step, StepType, TextStepData } from "../types";

/**
 * A factory that generates the correct concrete StepHandle implementation
 * for a given step.
 */
export class StepHandleFactory {
    static get(manager: WorkflowManager, step: Step<AnyStepData>) {
        switch (step.type) {
            case StepType.DigitalContent:
                return new DigitalContentStepHandle(manager, step as Step<DigitalContentStepData>, manager.getStepTags(step.stepName));
            case StepType.Information:
                return new InformationStepHandle(manager, step as Step<InformationStepData>, manager.getStepTags(step.stepName));
            case StepType.Question:
                return new QuestionStepHandle(manager, step as Step<QuestionStepData>, manager.getStepTags(step.stepName));
            case StepType.Text:
                return new TextStepHandle(manager, step as Step<TextStepData>, manager.getStepTags(step.stepName));
            case StepType.Illustration:
                return new IllustrationStepHandle(manager, step as Step<IllustrationStepData>, manager.getStepTags(step.stepName));
            case StepType.Picture:
                return new PictureStepHandle(manager, step as Step<PictureStepData>, manager.getStepTags(step.stepName));
            case StepType.Shape:
                return new ShapeStepHandle(manager, step as Step<ShapeStepData>, manager.getStepTags(step.stepName));
            case StepType.Material:
                return new MaterialStepHandle(manager, step as Step<MaterialStepData>, manager.getStepTags(step.stepName));
            case StepType.Model:
                return new ModelStepHandle(manager, step as Step<ModelStepData>, manager.getStepTags(step.stepName));
            case StepType.Frame:
                return new FrameStepHandle(manager, step as Step<FrameStepData>, manager.getStepTags(step.stepName));
            case StepType.Module:
                return new ModuleStepHandle(manager, step as Step<ModuleStepData>, manager.getStepTags(step.stepName));
            default:
                throw new UnhandledBehaviorError(`Step type ${step.type} not yet supported in Core SDK`);
        }
    }
}
